import { dateFns as moment } from '@pcln/date-fns-utils'
import pclnExpt from '@pcln/experimentation'
import { mark } from '@pcln/measure'
import get from 'lodash/get'
import throttle from 'lodash/throttle'
import React from 'react'
import { Route } from 'react-router-dom'

import { Check } from 'pcln-icons'

import { europeanCountriesList } from '../../../details-client/BaggageFeeComponent/helpers/europeanCountriesList'
import { isDesktopVP } from '../../util/displayHelpers'
import { buildCheckoutQuery } from '../../util/listingsHelpers'
import { RoutingHelper } from '../../util/routingHelper'
import { SETI } from '../../util/transformSETI'
import { flyDetailDeeplinkModel } from '../Legacy/fly-detail-deeplink-model/fly-detail-deeplink-model-factory'
import { flyFilterSelectionHistoryStorage } from '../Legacy/fly-filter-selection-history-storage/fly-filter-selection-history-storage'
import { flySliceSelectionStorage } from '../Legacy/fly-slice-selection-storage/fly-slice-selection-storage'

import { OverlayManager } from '../../../common-components/Overlay/OverlayManager'

import { logSearchError } from '../../util/clientLogger'
import { SBS_ROUTES, setSbsRouteParam } from '../../util/setSbsRouteParam'

import { pclnGptDartAds } from '../Ad/gpt-dart-ad'

import { newTabDetailsWithUpsell } from '../../util/brandedFares/newTabDetailsWithUpsell/newTabDetailsWithUpsell'

import { PERF_EVENTS } from '../../../common/constants/perfEvents'
import { generatePhoneBookNumber } from '../../../services/phoneBookCall'
import { generatePhoneBookPackagesNumber } from '../../../services/phoneBookPackagesCall'
import { populateListingsState } from './populateListingsState'

import { LogSelectItemListingsHelper } from '@mfs/client/common/log-ga-event/helpers/logSelectItemListingsHelper'
import '@mfs/common/tailwind.css'
import { Button, Dialog, Heading, Text } from 'pcln-design-system'
import {
  incrementSessionShowCount,
  isEligibleForAHCrossSell,
  shouldShowAHCrossSell,
} from '@pcln/horizon-package-components'
import { logAllSetiImpressions } from '../../../common/log-ga-event/logGaEvent-seti'
import { toShopSearchRedirect } from '../../../details-client/CrossSellModalAd/crossSellHelpers'
import { buildShopSearchRedirectObject } from '../../../details-client/util/buildShopSearchRedirectObject'
import { isServerSide } from '../../util/isServerSide'
import LazyFilterOverlay from '../LazyFilterOverlay/LazyFilterOverlay'
import {
  getMatchingFareBrandByPriceKey,
  getMatchingFareBrandIndex,
  getPriceByType,
} from '../Listings/SBSHelpers/SBSHelpers'
import { calculateLengthOfStay } from '../../../details-client/util/length-of-stay'
import { countFlightPassengers } from '../../../details-client/DetailsCTA/helper'
import { generatePropsForRecommendedPkgFlight } from '../RecommendedFlightBannerWrapper/helpers'
import { XSellAd, canRenderXSellAd } from '../RecommendedPackageDeal'
import { AHCrossSellModal } from '../AHCrossSellModal'
import ContentRenderer from './ContentRenderer'
import {
  buildAHCrossSellEligibilityArgs,
  logAHCrossSellInternalElementEvent,
} from '../AHCrossSellModal/helpers'
import { generatePhoneBookPackagesInput, getBundleTypeString, getPassengersCountHelper } from './helpers'

class ListingsContent extends React.PureComponent {
  constructor(props) {
    super(props)

    const translatedRequest = props.translatedRequest

    const {
      airports,
      searchReqAirports,
      slices,
      cabinClass,
      travelers,
      tripType,
      departingFrom,
      returningFrom,
      travelDate,
      returnDate,
      origin,
      destination,
    } = translatedRequest
    this.airports = airports
    this.origin = origin
    this.destination = destination
    this.cabinClass = cabinClass

    const filterHistory = flyFilterSelectionHistoryStorage

    this.overlayManager = new OverlayManager()
    this.appLoadTimestamp = new Date()
    this.timer = null

    const isDesktop = isServerSide ? !props.pclnBootstrapData?.isMobile : isDesktopVP()

    this.listingsLoadTimerStart = new Date()
    const formattedPurchaseWindow = moment(this.listingsLoadTimerStart).format().split('T')[0]
    this.purchaseWindow = moment(travelDate).diff(formattedPurchaseWindow, 'days')

    /**
     * TODO: Move props out of state that are not updated
     */
    this.state = {
      slicesURL: get(props.pclnBootstrapData, 'searchRequest.slicesURL'),
      listings: [],
      sbsListings: {
        1: [],
      },
      lastUpdateTime: null,
      loadingMessage: props.listingsLoadingMessage,
      searchKey: '',
      options: {
        adCount: 0,
        adsLength: pclnGptDartAds.length,
      },
      airportToCity: {},
      loadingMessageOffsetTop: null,
      showLoadingMessage: true,
      loadMoreRequestPending: false,
      showBaggageFeeModal: false,
      showErrorOverlay: get(props.pclnBootstrapData, 'hasBookingError', false),
      handleResize: throttle(this.handleResize, 300), // TODO: Check this later on
      isDesktop,
      isSBSQL: false,
      priceGuidance: {},
      seti: SETI,
      flySliceSelectionStorage,
      filterHistory,
      searchReqAirports,
      slices,
      cabinClass,
      travelers,
      tripType,
      departingFrom,
      returningFrom,
      travelDate,
      returnDate,
      origin,
      destination,
      // Fire Impressions only Once after the initial Listings load
      fireListingsImpressionsOnce: false,
      vipTier: 'member',
      showDialog: false,
      selectedDepartureSummaries: [],
      hasBeenUpsold: false,
      showAHCrossSellModal: false,
      ahCrossSellPendingSelection: null,
    }

    this.perPaxPricingText = tripType === 'RT' ? 'round-trip' : 'per person'

    // Constructor End

    /**
     * Used for backwards compatibility checking on non-SSR streaming path
     * Once ListingsV2 path is fully used, update accordingly to remove
     * all local selectedDepartureSummaries state in this component.
     */
    this.isNewDepartureSummariesState = typeof this.props.setSelectedDepartureSummaries === 'function'
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!prevState) {
      return null
    }
    const newState = {}

    const lastUpdateTime = get(nextProps, 'listings.lastUpdateTime')
    const isNewListingsLoad = lastUpdateTime && lastUpdateTime !== prevState.lastUpdateTime
    if (isNewListingsLoad) {
      const listingsState = populateListingsState({
        listingsContentState: prevState,
        listingsContentProps: nextProps,
        flySearchResponseData: nextProps.flySearchResponseData,
      })
      Object.assign(newState, listingsState)
    }

    if (isNewListingsLoad) {
      newState.sbsListings[nextProps.activeTabId] = newState.listings
    }

    if (Object.keys(newState).length) {
      return newState
    }

    return null
  }

  async componentDidMount() {
    if (this.timer) {
      clearTimeout(this.timer)
    } else {
      //Timer for forcing the listing page to reload for every 20 minutes.
      this.timer = setTimeout(() => {
        this.setState({
          showDialog: true,
        })
      }, 20 * 60000)
    }

    const { pclnBootstrapData } = this.props

    const { searchRequest = {}, partner = {} } = pclnBootstrapData
    if (!isServerSide) {
      window.addEventListener('resize', this.state.handleResize)
    }

    if (partner?.products?.flight) {
      searchRequest.plfCode = partner.products.flight.plfCode
    }

    const userCGUID = get(
      pclnBootstrapData,
      'requestLocals.webstats.clientGUID',
      'd1f5c150c10cfdbec036e58c52a96455'
    )
    const requestId = get(pclnBootstrapData, 'requestLocals.webstats.clientRequestId', 'd1f5125')
    const refid =
      pclnBootstrapData?.requestLocals?.referral?.sourceId + pclnBootstrapData?.requestLocals?.referral?.id

    const numOfPassengers = get(pclnBootstrapData, 'searchRequest.numberOfPassengers', 1)
    const cabinClass = get(pclnBootstrapData, 'searchRequest.params.cabin-class', 'ECO')

    const isDomestic = get(pclnBootstrapData, 'hasUSDestinationsOnly', true)

    const getLengthofStay = moment(this.state.returnDate).diff(this.state.travelDate, 'days')

    const airportsArray = Object.values(this.airports)
    const phoneBookInput = {
      requestId: requestId,
      cguid: userCGUID,
      refid: refid,
      clientDevice: this.state.isDesktop ? 'DESKTOP' : 'MOBILE',
      isTestNumber: false,
      advancedPurchaseWindow: this.purchaseWindow,
      currencyCode: 'USD',
      origCountryCode: airportsArray[0].countryCode,
      destCountryCode: airportsArray[1].countryCode,
      clientCountryCode: pclnBootstrapData?.requestLocals?.locale?.countryCode,
      clientIp:
        pclnBootstrapData?.requestLocals?.locale?.ipAddr ||
        pclnBootstrapData?.requestLocals?.customer?.clientIp,
      originAirport: this.state.departingFrom.airportCode,
      destinationAirport: this.state.returningFrom.airportCode,
      isInternational: !isDomestic,
      passengers: numOfPassengers,
      isError: this.props.listingsHasErrored,
      travelStartDate: this.state.travelDate,
      travelEndDate: this.state.returnDate,
      searchOptions: {
        cabinClass: cabinClass,
      },
      pageType: 'LISTINGS',
      tripType: this.state.tripType,
    }

    if (this.state.tripType !== 'OW') {
      phoneBookInput.lengthOfStay = getLengthofStay
    }

    if (!isServerSide && this.state.tripType !== 'MD') {
      try {
        let phoneBookInfo
        if (
          this.props.isPackageListings &&
          this.props.pclnBootstrapData?.features?.whiteLabel?.phoneAgentPackagePlacementsEnabled
        ) {
          const phoneBookPackagesInput = await generatePhoneBookPackagesInput(pclnBootstrapData)
          phoneBookInfo = await generatePhoneBookPackagesNumber(phoneBookPackagesInput)
        } else if (
          !this.props.isPackageListings &&
          this.props.pclnBootstrapData?.features?.whiteLabel?.phoneAgentFlightPlacementsEnabled
        ) {
          phoneBookInfo = await generatePhoneBookNumber(phoneBookInput)
        }
        this.props.setPhoneBookInfo(phoneBookInfo)
      } catch (e) {
        logSearchError('Phone Book API Error', e)
      }
    }

    if (this.state.tripType !== 'MD') {
      logAllSetiImpressions(pclnBootstrapData?.seti)
    }

    if (this.props.isRecommendedFlightBannerEligible) {
      pclnExpt.fireImpression('PKG_AIR_DYNAMIC_BANNER_SORT_TEST')
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lastUpdateTime !== this.props.lastUpdateTime) {
      this.airSearchMsToLoad = Math.ceil(new Date() - this.appLoadTimestamp)
    }

    // listingsIsLoading trigger for the first slice and second slice only
    if (
      this.state.tripType !== 'MD' &&
      !this.props.listingsIsLoading &&
      prevProps.listingsIsLoading &&
      this.props.activeTabId !== prevProps.activeTabId
    ) {
      setSbsRouteParam(SBS_ROUTES[this.props.activeTabId])
    }
  }

  componentWillUnmount() {
    if (!isServerSide) {
      window.removeEventListener('resize', this.state.handleResize)
    }
  }

  loadMore = () => {
    // Only load more listings if there are no overlays open (e.g. mWeb details, filters). For some reason,
    // the infinite scroll component triggers when the scroll position within the overlay reaches the bottom.
    if (this.overlayManager.getOpenModalCount() < 1) {
      this.props.listingsLoadMore(
        this.props.pclnBootstrapData,
        this.state.sbsListings[this.props.activeTabId],
        this.props.filterValues
      )
    }
  }

  handleResize = () => {
    this.setState({
      isDesktop: isDesktopVP(),
    })
  }

  handleDepartureSliceClick = (newlySelectedDepartureItinerary) => {
    // GA4 Tagging for Departure Flight
    // Update "ticket" array in state for logging on details load

    if (newlySelectedDepartureItinerary.fareBrands.length > 1) {
      const fareBrandSelectionIndex = newlySelectedDepartureItinerary.fareBrands.findIndex(
        (fb) => fb.name === newlySelectedDepartureItinerary.fareBrandName
      )
      if (fareBrandSelectionIndex > 0) {
        this.setState({ hasBeenUpsold: true })
      }
    }

    const sliceKey = get(newlySelectedDepartureItinerary, 'slices[0].sliceKey', '')
    const { activeTabId, updateActiveTabId } = this.props
    const { tripType } = this.state
    updateActiveTabId(activeTabId + 1)

    if (tripType === 'MD') {
      if (this.isNewDepartureSummariesState) {
        this.props.setSelectedDepartureSummaries([
          ...this.props.selectedDepartureSummaries,
          newlySelectedDepartureItinerary,
        ])
      } else {
        this.setState({
          selectedDepartureSummaries: [
            ...this.state.selectedDepartureSummaries,
            newlySelectedDepartureItinerary,
          ],
        })
      }
    } else {
      LogSelectItemListingsHelper({
        props: this.props,
        state: this.state,
        airports: this.airports,
        cabinClass: this.cabinClass,
        itinerary: newlySelectedDepartureItinerary,
        isFiltersApplied: this.props.isFiltersAppliedForGa,
      })
      if (this.isNewDepartureSummariesState) {
        this.props.setSelectedDepartureSummaries([newlySelectedDepartureItinerary])
      } else {
        this.setState({
          selectedDepartureSummaries: [newlySelectedDepartureItinerary],
        })
      }
    }

    let prevSliceKey =
      this.state.selectedDepartureSummaries?.[this.state.selectedDepartureSummaries?.length - 1]?.slices?.[0]
        ?.sliceKey || ''

    if (this.isNewDepartureSummariesState) {
      prevSliceKey =
        this.props.selectedDepartureSummaries?.[this.props.selectedDepartureSummaries?.length - 1]
          ?.slices?.[0]?.sliceKey || ''
    }

    const willMakeReturnSliceAirSearchCall = (prevSliceKey && prevSliceKey !== sliceKey) || !prevSliceKey

    window.scrollTo(0, 0)

    flySliceSelectionStorage.set({ sliceKey, sliceId: activeTabId })

    const matchingFareBrand = getMatchingFareBrandByPriceKey({
      fareBrands: newlySelectedDepartureItinerary?.fareBrands,
      priceKey: newlySelectedDepartureItinerary?.priceKey,
    })

    const avgPrice = getPriceByType({ prices: matchingFareBrand?.price, type: 'AVG_PRICE' })?.amount

    const selectedPriceIndex = getMatchingFareBrandIndex({
      fareBrands: newlySelectedDepartureItinerary?.fareBrands,
      priceKey: newlySelectedDepartureItinerary?.priceKey,
    })

    const selectedFareBrand = {
      avgPrice,
      name: matchingFareBrand?.name,
      sliceId: activeTabId,
      selectedPriceIndex: selectedPriceIndex >= 0 ? selectedPriceIndex : null,
    }

    this.props.setSelectedFareBrand?.({ selectedFareBrand })
    if (willMakeReturnSliceAirSearchCall) {
      this.makeSliceSelection('sliceSelection')
    } else {
      // Dont load previously saved filter info if new call is being made
      this.props.loadSavedFilterInfo({ tabId: 2 })
    }
  }

  // TODO: Simplify the logic
  retrieveCheckoutQuery = (itineraryKey, upsellToken, itinerary) => {
    let adults
    let children
    let infants
    let cabinClass

    const { passengers, searchOptions } = this.props.airSearchRequestModel

    adults = passengers.adults
    children = passengers.children
    infants = passengers.infants
    cabinClass = searchOptions.cabinClass || 'ECO'

    const { searchRequest, bundleComponents, isPackageListings } = this.props.pclnBootstrapData
    const { params = {} } = searchRequest

    const { index: flyComponentIndex, key: componentKey } =
      bundleComponents?.find((comp) => comp?.type === 'FLY') ?? {}
    const bundleType = getBundleTypeString(bundleComponents, isPackageListings)
    const {
      type: desktopExD,
      seti: setiOverride, // May not be present
      'seti-default': setiOverrideDefault,
      'search-type': searchType,
      refclickid,
      'cart-key': cartKey,
      'usp-cache-key': uspCacheKey,
    } = params

    return buildCheckoutQuery({
      itinerary,
      adults,
      children,
      infants,
      cabinClass,
      setiOverride,
      setiOverrideDefault,
      refclickid,
      desktopExD,
      tripType: this.state.tripType,
      searchType,
      cartKey,
      uspCacheKey,
      flyComponentIndex,
      componentKey,
      bundleType,
    })
  }

  buildDetailsUrl = (id, itinerary, checkoutUrl, searchKey, upsellToken, workflowId, isUpsold) => {
    const { slicesURL } = this.state
    const offerToken = this.props.pclnBootstrapData?.offerToken
    const userActionType = this.props.pclnBootstrapData?.searchRequest?.params?.userActionType

    if (upsellToken) {
      return newTabDetailsWithUpsell({
        token: upsellToken,
        slicesURL,
        itinerary,
        checkoutUrl,
        offerToken,
        workflowId,
        userActionType,
      })
    }
    return newTabDetailsWithUpsell({
      token: id,
      slicesURL,
      searchKey,
      itinerary,
      checkoutUrl,
      offerToken,
      workflowId,
      userActionType,
      isUpsold,
    })
  }

  onPackageListingItemSelect = ({ itinerary }) => {
    LogSelectItemListingsHelper({
      props: this.props,
      state: this.state,
      airports: this.airports,
      cabinClass: this.cabinClass,
      itinerary,
      isFiltersApplied: this.props.isFiltersAppliedForGa,
      needsDelay: false,
    })

    const { itemKey, priceKey, slices, price } = itinerary
    const { tripType } = this.state
    const { searchRequest, bundleComponents } = this.props.pclnBootstrapData
    const flyBundleComponent = bundleComponents?.find((comp) => comp?.type === 'FLY') ?? {}

    let itinerarySlices = slices
    const selectedDepartureSummaries = this.isNewDepartureSummariesState
      ? this.props.selectedDepartureSummaries
      : this.state.selectedDepartureSummaries
    const completeItin = tripType === 'RT' ? [selectedDepartureSummaries?.[0], itinerary] : [itinerary]

    // Add fare brand name to each segment to show on Trip Summary
    completeItin.forEach((itin) => {
      itin.slices[0].segments.forEach((segment, segIndex) => {
        segment.cabinName = itin.allFareBrandNames?.[segIndex] || itin.allFareBrandNames?.[0]
      })
    })

    if (tripType === 'RT') {
      itinerarySlices = completeItin.map((itin) => itin.slices?.[0])
      if (itinerarySlices[1]?.id === 1) {
        itinerarySlices[1].id = 2
      }
    }

    const shopSearchRedirectObj = buildShopSearchRedirectObject({
      proposalComponents: itinerary.proposalComponents,
      itemKey,
      priceKey,
      componentKey: flyBundleComponent?.key,
      searchRequest,
      flyIndex: flyBundleComponent?.index,
      price,
      itinerarySlices,
    })

    toShopSearchRedirect(shopSearchRedirectObj)
  }

  tryShowAHCrossSell = (selection) => {
    const { id, itinerary, upsellToken } = selection

    const eligibilityArgs = buildAHCrossSellEligibilityArgs({
      id,
      itinerary,
      pclnBootstrapData: this.props.pclnBootstrapData,
      activeTabId: this.props.activeTabId,
      selectedDepartureSummaries: this.props.selectedDepartureSummaries,
      tripType: this.state.tripType,
      travelDate: this.state.travelDate,
      returnDate: this.state.returnDate,
      maxShowCount: this.props.ahCrossSellMaxShowCount,
    })

    if (isEligibleForAHCrossSell(eligibilityArgs)) {
      pclnExpt.fireImpression('PKG_AH_CROSSSELL_RETURN_FLIGHT_LISTING')
    }

    if (shouldShowAHCrossSell(eligibilityArgs)) {
      incrementSessionShowCount()
      this.setState({
        showAHCrossSellModal: true,
        ahCrossSellPendingSelection: { id, itinerary, upsellToken },
      })
      return true
    }

    return false
  }

  onListingItemSelect = (selection) => {
    if (this.tryShowAHCrossSell(selection)) return
    this.navigateToDetails(selection)
  }

  navigateToDetails = ({ id, itinerary, upsellToken }) => {
    const sessionSearchKey = this.props.airSearchRequestModel.searchSessionKey

    let isUpsold = this.state.hasBeenUpsold || false

    if (itinerary.fareBrands.length > 1) {
      const fareBrandSelectionIndex = itinerary.fareBrands.findIndex((fb) => fb.priceKey === id)
      if (fareBrandSelectionIndex > 0) {
        isUpsold = true
      }
    }

    LogSelectItemListingsHelper({
      props: this.props,
      state: this.state,
      airports: this.airports,
      cabinClass: this.cabinClass,
      itinerary: itinerary,
      isFiltersApplied: this.props.isFiltersAppliedForGa,
    })
    const checkoutUrl = this.retrieveCheckoutQuery(id, upsellToken, itinerary)

    const { workflowId } = this.props.pclnBootstrapData
    const detailsUrl = this.buildDetailsUrl(
      id,
      itinerary,
      checkoutUrl,
      sessionSearchKey,
      upsellToken,
      workflowId,
      isUpsold
    )

    window.open(
      `${detailsUrl}`,
      this.props.pclnBootstrapData?.features?.whiteLabel?.iframeEnabled ? '_self' : '_blank'
    )
  }

  handleAHCrossSellAddHotelDismiss = () => {
    this.setState({ showAHCrossSellModal: false, ahCrossSellPendingSelection: null })
  }

  handleAHCrossSellDismiss = (reason) => {
    logAHCrossSellInternalElementEvent(
      reason === 'continue_flight_only' ? 'continue_with_flight' : 'close_promotion'
    )

    const pendingSelection = this.state.ahCrossSellPendingSelection
    this.setState({ showAHCrossSellModal: false, ahCrossSellPendingSelection: null }, () => {
      if (pendingSelection) {
        this.navigateToDetails(pendingSelection)
      }
    })
  }

  onListingsMount = () => {
    if (!isServerSide) {
      mark(PERF_EVENTS.renderGraphListingsEnd)
      // fire BOOMR after 2000 seconds of listings Mount
      if (window !== 'undefined' && window.BOOMRautorun !== 'undefined' && !window.BOOMRautorun) {
        const BOOMR_FIRE_DELAY = 2000
        setTimeout(() => {
          if (window && window.BOOMR) {
            window.BOOMR.page_ready()
          }
        }, BOOMR_FIRE_DELAY)
      }
    }
  }

  makeSliceSelection = (displayType = '') => {
    this.props.listingsFilterCall(this.props.pclnBootstrapData, displayType)
  }

  onSliceFilter = () => {
    window.scrollTo(0, 0)
  }

  setBaggageFeeVisibility = (show) => {
    this.setState({
      showBaggageFeeModal: show,
    })
  }

  openBaggageFeesModal = () => this.setBaggageFeeVisibility(true)
  closeBaggageFeeOverlay = () => this.setBaggageFeeVisibility(false)

  setErrorOverlay = (show) => {
    this.setState({
      showErrorOverlay: show,
    })
  }

  closeErrorOverlay = () => this.setErrorOverlay(false)

  searchRefId = () => {
    const { pclnBootstrapData } = this.props
    const { requestLocals = {} } = pclnBootstrapData
    return get(requestLocals, 'referral.sourceId', '') + get(requestLocals, 'referral.id', '')
  }

  render() {
    const {
      isSBSQL,
      seti: setiDetails,
      travelDate,
      returnDate,
      tripType,
      sponsoredCarrier,
      showErrorOverlay,
      sbsListings,
      minimumRetailPrice,
      crossSellControlObject,
    } = this.state

    const renderSelectedDepartureSummaries = this.props.selectedDepartureSummaries

    const {
      activeTabId,
      pclnBootstrapData,
      listingsIsLoading,
      listingsHasErrored,
      disableLoadingOverlay,
      fetchedInitialListings,
      displayInfiniteScrollLoadMore,
      brandReference,
      currentMobileFilter,
      listingsMetaData,
      forceHeaderOpen,
      setPriceWatchState,
      priceWatchState,
      handleTabChange,
      isRecommendedFlightBannerEligible,
      isHorizonListing,
      recommendedListings,
    } = this.props

    const enableSOPQ = pclnBootstrapData?.features?.whiteLabel?.flightsExpressDealsEnabled

    const enableExpressDealVip = pclnBootstrapData?.features?.flights?.enableExdVip

    const { searchRequest } = pclnBootstrapData
    const defaultFilterAirports = get(this.props, 'filterValues.defaults.AIRPORTS', [])

    const xSellCanRender =
      activeTabId === 1 &&
      canRenderXSellAd(pclnBootstrapData, crossSellControlObject) &&
      pclnBootstrapData?.features?.whiteLabel?.packagesCrossSellEnabled &&
      !this.props.isPackageListings

    const xSellAd = xSellCanRender ? (
      <XSellAd {...this.props} crossSellControlObject={crossSellControlObject} />
    ) : undefined

    // Determine which components to display
    const showLoadingOverlay = !disableLoadingOverlay && listingsIsLoading && !listingsHasErrored
    const displayListings = fetchedInitialListings && !listingsHasErrored
    const displayLoadMore = displayListings && displayInfiniteScrollLoadMore[activeTabId]?.loadMore
    const displayErrorPage = listingsHasErrored && !showLoadingOverlay
    const hasUSDestinationsOnly = pclnBootstrapData.hasUSDestinationsOnly
    const bpgLeftRailDisplay = get(setiDetails, 'AIR_LISTINGS_BPG_PLACEMENT.isVariant', false)
    const minRetailPrice = minimumRetailPrice || get(listingsMetaData, 'minimumRetailPrice', 0)

    const hasEuropeFlight = (airports) => {
      let flightIncludesEurope = false
      if (airports) {
        let airportsArray = Object.values(airports)
        airportsArray.forEach((airportStop) => {
          if (europeanCountriesList.indexOf(airportStop.countryName) > -1) {
            flightIncludesEurope = true
          }
        })
      }
      return flightIncludesEurope
    }

    const logExdClick = (itinerary) => {
      const isUserSignedIn = Boolean(this.props?.pclnBootstrapData?.authUser)
      LogSelectItemListingsHelper({
        props: this.props,
        state: this.state,
        airports: this.airports,
        cabinClass: this.cabinClass,
        itinerary,
        isFiltersApplied: this.props.isFiltersAppliedForGa,
        isUserSignedIn,
      })
    }

    let listingsToPassDown = sbsListings[activeTabId] || []

    let recommendedFlightBannerListing = null
    if (isRecommendedFlightBannerEligible) {
      recommendedFlightBannerListing = listingsToPassDown.find(
        (listing) => listing.hasRecommendedBundleProposal
      )
      if (pclnExpt.isVariant('PKG_AIR_DYNAMIC_BANNER_SORT_TEST') && !recommendedFlightBannerListing) {
        // we are getting the recommended deal from both arrays
        // it seems that our recommended can also be the fly standalone recommended sometimes
        // let's fix this on flyQl after this experiment is over
        // https://github.com/pcln/fly-ql/blob/98f0dbf993088871ed8c35792024d9166ce08382/src/server/controllers/airSearchFF/helpers/buildAirSearchResponse/buildAirSearchResponse.js#L304
        // We should check if composedItinerary.hasRecommendedBundleProposal === true and only push to listings
        const dealFromRecommended = recommendedListings?.[1]?.find(
          (listing) => listing.hasRecommendedBundleProposal
        )
        if (dealFromRecommended) {
          recommendedFlightBannerListing = dealFromRecommended
        }
      }
    }

    const passengerCount = getPassengersCountHelper(searchRequest.params)
    const totalPassengerCount = countFlightPassengers({
      passengers: passengerCount,
      pclnBootstrapData,
    })

    const recommendedFlightBannerListingProps = generatePropsForRecommendedPkgFlight({
      itinerary: recommendedFlightBannerListing,
      pclnBootstrapData,
      listingsMetaData,
      travelDate,
      lengthOfStay: calculateLengthOfStay(travelDate, returnDate),
      bannerIndex: null,
      totalPassengerCount,
      tripType: this.state.tripType,
    })

    // only want to show banner if package savings for banner is > 0
    const shouldShowRecommendedFlightBanner = (recommendedFlightBannerListingProps?.totalSavings || 0) > 0

    // pass new props to listings down into this object directly instead of feeding it down every single component
    const listingsPropsObject = {
      ...(shouldShowRecommendedFlightBanner
        ? {
            recommendedFlightBannerListing,
            recommendedFlightBannerListingProps,
          }
        : {}),
    }

    const contentRendererProps = {
      listingsPropsObject: listingsPropsObject,
      phoneBookInfo: this.state.phoneBookInfo,
      activeTabId: activeTabId,
      airportToCity: this.state.airportToCity,
      altDeals: this.props.altDeals,
      searchRequest: searchRequest,
      brandReference: brandReference,
      closeBaggageFeeOverlay: this.closeBaggageFeeOverlay,
      closeErrorOverlay: this.closeErrorOverlay,
      currentMobileFilter: currentMobileFilter,
      deeplinkModelToken: flyDetailDeeplinkModel.get().token,
      departingFrom: this.state.departingFrom,
      displayAds: this.props.displayAds,
      displayErrorPage: displayErrorPage,
      displayInfiniteScrollLoadMore: displayInfiniteScrollLoadMore,
      displayListings: displayListings,
      displayLoadMore: displayLoadMore,
      exdCarriers: this.state.exdCarriers,
      fetchedInitialListings: fetchedInitialListings,
      forceHeaderOpen: forceHeaderOpen,
      hasUSDestinationsOnly: hasUSDestinationsOnly,
      handleDepartureSliceClick: this.handleDepartureSliceClick,
      handleTabChange: handleTabChange,
      enableSOPQ: enableSOPQ,
      isDesktop: this.state.isDesktop,
      isIE: get(pclnBootstrapData, 'requestLocals.isIE', false),
      isSliceSelected: this.state.isSliceSelected,
      isSBSQL: isSBSQL,
      selectedDepartureSummaries: this.isNewDepartureSummariesState
        ? this.props.selectedDepartureSummaries
        : this.state.selectedDepartureSummaries,
      listings: listingsToPassDown,
      listingsIsLoading: this.props.listingsIsLoading,
      listingsLoadingMessage: this.props.listingsLoadingMessage,
      listingsSaleStyle: get(pclnBootstrapData, 'saleStyles.listings', {}),
      loadingMessage: this.state.loadingMessage,
      loadMore: this.loadMore,
      minRetailPrice: minRetailPrice,
      onListingItemSelect: this.onListingItemSelect,
      onPackageListingItemSelect: this.onPackageListingItemSelect,
      onListingsMount: this.onListingsMount,
      onSliceFilter: this.onSliceFilter,
      onUpsellSelect: this.onUpsellSelect,
      openBaggageFeesModal: this.openBaggageFeesModal,
      pclnGptDartAds: pclnGptDartAds,
      perPaxPricingText: this.perPaxPricingText,
      hasEuropeFlight: hasEuropeFlight(this.airports),
      priceGuidance: this.state.priceGuidance,
      returnDate: returnDate,
      returningFrom: this.state.returningFrom,
      searchKey: this.state.searchKey,
      searchRefId: this.searchRefId(),
      SETI: this.props.SETI,
      setiDetails: setiDetails,
      showBaggageFeeModal: this.state.showBaggageFeeModal,
      showErrorOverlay: showErrorOverlay,
      showLoadingOverlay: showLoadingOverlay,
      slices: this.props.slices,
      sponsoredCarrier: sponsoredCarrier,
      trafficSource: pclnBootstrapData?.requestLocals?.referral?.trafficSource,
      travelDate: travelDate,
      tripType: tripType,
      xSellAd,
      bpgLeftRailDisplay: bpgLeftRailDisplay,
      defaultFilterAirports: defaultFilterAirports,
      hasExpressDeal: this.props.hasExpressDeal,
      listingsMetaData: listingsMetaData,
      cancelTextColor: 'text.light',
      cancelFooterIcon: <Check size={16} mr={1} />,
      vipTier: '',
      enableExpressDealVip: enableExpressDealVip,
      searchSlices: get(searchRequest, 'slices', []),
      logExdClick: logExdClick,
      isPackageListings: this.props.isPackageListings,
      packageType: this.props.packageType,
      partner: pclnBootstrapData?.partner,
      setPriceWatchState,
      priceWatchState,
      crossSellControlObject,
      handleHotelCrossSellClick: this.handleHotelCrossSellClick,
      bundleType: getBundleTypeString(
        pclnBootstrapData.bundleComponents,
        pclnBootstrapData.isPackageListings
      ),
      purchaseWindow: this.purchaseWindow,
      theme: this.props.theme,
      isHorizonListing,
      listingsHasErrored,
    }

    /**
     *  Please DO NOT delete <React.StrictMode>. Used to find issues with React in development
     */
    return (
      // <React.StrictMode>
      <>
        <div
          style={{ position: 'fixed', bottom: '-115px', right: '5vw', width: '90vw', zIndex: 500 }}
          id='listing-toast-container'
        ></div>
        {this.state.showDialog ? (
          <Dialog
            headerColorScheme='neutralDarkOnLightest'
            headerContent={
              <center>
                <Heading.h4 fontSize={'20px'}>Welcome Back</Heading.h4>
              </center>
            }
            open={this.state.showDialog}
            p={2}
            zIndex={99}
            showCloseButton={false}
            onOpenChange={(open) => (open ? null : window.location.reload())}
          >
            <Text textAlign='center' fontSize={'14px'} px={2}>
              Prices have probably changed since you stepped away
            </Text>
            <center>
              <Button mt={2} mb={3} onClick={() => window.location.reload()}>
                Refresh My Results
              </Button>
            </center>
          </Dialog>
        ) : null}

        <Route
          path={RoutingHelper.routePaths.filters}
          render={() => {
            if (!fetchedInitialListings) {
              return null
            }

            return <LazyFilterOverlay />
          }}
        />
        <Route
          path={RoutingHelper.routePaths.listings}
          render={() => {
            return <ContentRenderer {...contentRendererProps} />
          }}
        />
        {this.state.showAHCrossSellModal && (
          <AHCrossSellModal
            returningFrom={this.state.returningFrom}
            destination={this.destination}
            pclnBootstrapData={pclnBootstrapData}
            listingsMetaData={listingsMetaData}
            selectedDepartureSummaries={renderSelectedDepartureSummaries}
            pendingSelection={this.state.ahCrossSellPendingSelection}
            travelDate={travelDate}
            returnDate={returnDate}
            isDesktop={this.state.isDesktop}
            originAirport={this.origin}
            destinationAirport={this.destination}
            totalPassengerCount={totalPassengerCount}
            onDismiss={this.handleAHCrossSellDismiss}
            onCloseModal={this.handleAHCrossSellAddHotelDismiss}
          />
        )}
      </>
      // </React.StrictMode>
    )
  }
}

export { ListingsContent }
